<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">search</i>
                        </div>
                        <h4 class="card-title ">Filtros</h4>
                    </div>
                    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" novalidate="novalidate" autocomplete="off">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger': validation.reference != ''}">
                                        <label for="reference" class="bmd-label-floating">Tipo</label>
                                        <model-list-select 
                                            class="form-control"
                                            :list="types_report"     
                                            option-value="id"
                                            option-text="name"
                                            placeholder="Tipo de relatório"
                                            v-model="form.reference"
                                            @input="getInfoData(form.reference)">
                                        </model-list-select>
                                        <label v-if="validation.reference != ''" id="reference-error" class="error" for="reference">{{ validation.reference }}</label>
                                    </div>
                                </div>
                                
                                <div class="col-md-8">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.date_at != null}">
                                        <label for="interval" class="bmd-label-floating">Lista de metas <b>{{ this.form.reference.trim() != '' ? this.types_report.filter(_ => _.id == this.form.reference)[0].name : ''}}</b></label>
                                        
                                        <select name="interval" id="interval" class="form-control " v-model="form.interval">
                                            <option value="">Todos</option>
                                            <optgroup v-for="iterator in listOfGoals" :key="iterator.id" :label="iterator.name">
                                                <option v-for="item in iterator.goals" :key="item.id" :value="item">
                                                    De {{ item.date_init | moment('DD/MM/YYYY') }} até {{ item.date_end | moment('DD/MM/YYYY') }} - Meta: {{ item.description }}({{item.goal}})
                                                </option>
                                            </optgroup>
                                        </select>

                                    </div>
                                </div>
                            </div>
                            <!-- <div class="row">
                                <div class="col-sm-12 md-layout-item">

                                        <md-field>
                                            <label for="interval">Lista de metas <b>{{ this.form.reference.trim() != '' ? this.types_report.filter(_ => _.id == this.form.reference)[0].name : ''}}</b></label>
                                            <md-select v-model="form.interval" name="interval" id="interval" md-dense>

                                                <md-optgroup v-for="iterator in listOfGoals" :key="iterator.id" :label="iterator.name">
                                                    <md-option v-for="item in iterator.goals" :key="item.id" :value="item.description">{{ item.description }}</md-option>
                                                </md-optgroup>

                                            </md-select>
                                        </md-field>
                                </div>
                            </div> -->
                        </div>
                        <div class="card-footer">
                            <button type="reset" class="btn btn-fill btn-outline-danger">Limpar</button>
                            <button type="submit" class="btn btn-fill btn-rose">Gerar</button>
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default {
        data() {
            return {
                form: {
                    reference: '',
                    interval : '',
                },
                validation: {
                    reference: '',
                    interval : '',
                },
                types_report : [
                                { id : 'team', name : 'Por Equipe'},
                                { id : 'profile' , name : 'Por Perfil'},
                                { id : 'branche'   , name : 'Por Loja'},
                            ],
                listOfGoals : []
            };
        },
        methods: {
            async getInfoData( elem ){
                this.form.interval = '';
                switch (elem) {
                    case 'team':
                            this.getTeams();
                            setTimeout( _ => this.listOfGoals = this.$store.state.teams.itens, 300);
                        break;
                    case 'profile':
                            this.getProfiles();
                            setTimeout( _ => this.listOfGoals = this.$store.state.profiles.itens, 300);
                        break;
                    case 'branche':
                            this.getBranches();
                            setTimeout( _ => this.listOfGoals = this.$store.state.branches.itens, 300);
                        break;
                
                    default:
                        break;
                }

            },
            async getTeams() {
                var self = this;

                self.$root.$emit('onLoading');

                const response = self.$store.dispatch('teams/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
             async getProfiles() {
                var self = this;

                self.$root.$emit('onLoading');

                const response = self.$store.dispatch('profiles/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
            async getBranches() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('branches/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
            onReset() {
                this.form = {
                    reference: '',
                    interval: ''
                };
            },
            onSubmit() {
                var self = this;
                var valid = true;

                self.validation = {
                    reference : ''

                };

                if (self.form.reference == '') {
                    valid = false;
                    self.validation.reference = 'Informe o tipo de relatório LOJA / PERFIL / EQUIPE!';
                }

                if (valid) 
                {
                    var serialize = JSON.stringify(self.form);
                    window.open("print-production-rating?form=" + serialize, '_blank');
                }
            }
        }
    }
</script>